import { useState } from 'react';
import { Alert, Box, Button, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { HS_AGENT, hsRequest } from './api';
import { guidance } from './guidance';

function localInput(value?: string) {
    if (!value) return '';
    const date = new Date(value);
    if (!Number.isFinite(+date)) return '';
    return new Date(+date - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
export function LeadPlan({ lead, onChanged }: { lead: any; onChanged: () => any }) {
    const [action, setAction] = useState(lead.nextAction || '');
    const [date, setDate] = useState(localInput(lead.followUpAt));
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    async function save(clear = false) {
        setError(''); setSuccess('');
        const parsed = date ? new Date(date) : null;
        if (!clear && parsed && (!Number.isFinite(+parsed) || +parsed <= Date.now() || +parsed > Date.now() + 7 * 86400000)) { setError('Escolha um horário futuro, em até 7 dias.'); return; }
        if (!clear && date && !action.trim()) { setError('Descreva o que precisa fazer no retorno.'); return; }
        setBusy(true);
        try {
            await hsRequest('PUT', `${HS_AGENT}/leads/${lead.id}/workflow`, { nextAction: action, followUpAt: clear || !parsed ? null : parsed.toISOString() });
            if (clear) setDate('');
            setSuccess(clear ? 'Retorno removido. Cliente na lista de ações.' : 'Plano de atendimento salvo.');
            onChanged();
        } catch (e: any) { setError(e.message); }
        finally { setBusy(false); }
    }
    return <Box sx={{ p: { xs: 2, sm: 3 }, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle1" fontWeight={700}>Próxima ação e retorno</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{guidance(lead).action}</Typography>
        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}
        {success ? <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert> : null}
        <TextField fullWidth multiline minRows={2} label="Próxima ação" value={action} disabled={busy} inputProps={{ maxLength: 300 }} onChange={(e) => setAction(e.target.value)} helperText="Registre o que falta resolver. Não inclua dados pessoais." />
        <TextField fullWidth type="datetime-local" label="Retornar em (horário local)" value={date} disabled={busy} onChange={(e) => setDate(e.target.value)} InputLabelProps={{ shrink: true }} sx={{ mt: 2 }} helperText="Envie o primeiro contato antes de agendar. O lembrete não envia mensagens e mantém o robô pausado." />
        <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
            <LoadingButton variant="contained" loading={busy} onClick={() => save()}>Salvar plano</LoadingButton>
            {date ? <Button disabled={busy} onClick={() => save(true)}>Remover retorno</Button> : null}
        </Box>
    </Box>;
}
